module.exports = __webpack_public_path__ + "static/media/ole_ole_247sc.f5330491.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/climasense/paratrioza/curativa/ole_ole_247sc.png
// module id = 2002
// module chunks = 3